import { type ComponentPropsWithoutRef, forwardRef } from 'react';
import { type Editor, EditorContent } from '@tiptap/react';
import { cn } from '@/utils';
import { WithUnderline } from '../WithUnderline';
import { Placeholder } from './Placeholder';
interface TextEditorInputProps extends ComponentPropsWithoutRef<typeof EditorContent> {
  editor: Editor | null;
  className?: string;
  placeholder?: string;
  placeholderClassName?: string;
  editorClassName?: string;
}
export const TextEditorInput = forwardRef<HTMLDivElement, TextEditorInputProps>(({
  editor,
  className,
  onFocus,
  placeholder,
  placeholderClassName,
  editorClassName,
  ...rest
}, ref) => {
  return <WithUnderline ref={ref} tabIndex={0} onFocus={e => {
    e.stopPropagation();
    editor?.commands.focus();
  }} className={cn('w-full cursor-text', className)}>
        {placeholder && editor?.isEmpty && <Placeholder placeholder={placeholder} className={placeholderClassName} />}
        <EditorContent {...rest} tabIndex={-1} editor={editor} className={cn('w-full text-heading-md-bold', editorClassName)} />
      </WithUnderline>;
});